"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_MAPPING = {
    prefix: 'user',
    getFacilityUsers: {
        path: '/getFacilityUsers',
        parameter: '/:facilityId'
    },
    addUser: {
        path: '/addUser',
    },
    deleteUserById: {
        parameter: '/:id',
        path: '/deleteUserById',
    },
    resetPassword: {
        path: '/resetPassword'
    },
    adminUsers: {
        path: '/adminUsers'
    },
    managementUsers: {
        path: '/managementUsers'
    },
    updateUser: {
        path: '/updateUser',
        parameter: '/:id'
    },
    getAllAllowedUsers: {
        path: '/getAllAllowedUsers',
    },
    getUserById: {
        parameter: '/:id',
        path: '/getUserById',
    },
    updateUserStatus: {
        parameters: '/:id/status',
        path: '/updateUserStatus',
    },
    getChainManager: {
        parameter: '/:chainId',
        path: '/getChainManager'
    },
    setupChainUsers: {
        path: '/setupChainUsers'
    }
};
